import script from "./FilaCuota.vue?vue&type=script&setup=true&lang=js"
export * from "./FilaCuota.vue?vue&type=script&setup=true&lang=js"

import "./FilaCuota.vue?vue&type=style&index=0&id=4c0a9b13&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0a9b13"]])

export default __exports__